import { Route } from '@/Enums/Routes/Route.enum';
import { IChangeLogHistoryGridRow } from '@/Interfaces/ChangeLogHistory.interface';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { Link } from 'react-router-dom';

const CampaignCell = ({ row }: GridRenderCellParams<IChangeLogHistoryGridRow>) => {
  if (!row.campaignId || !row.campaignName) {
    return <span>—</span>;
  }

  return (
    <Link className='text-[#2E87FD]' to={`${Route.CAMPAIGN_MANAGEMENT}/${row.campaignId}`}>
      {row.campaignName} (ID: {row.campaignId})
    </Link>
  );
};

export default CampaignCell;
